import { Action, Method, NO_VALUE } from '../../constants.js';
export const buildLastLoginMethodPayload = (payloadParams) => {
    const { loginSource, lastLoginMethod } = payloadParams;
    const isEmail = lastLoginMethod === 'email';
    const trackingPayload = {
        method: Method.LINK,
        triggeringEventPlace: {
            componentId: 'candidateLoginRegisterModal',
            linkName: isEmail ? 'socialButtonNotVisible' : 'socialButtonVisible',
        },
        trackingData: {
            loginSource,
            elementActioned: 'socialButton',
            componentState: isEmail
                ? 'recommendedLoginFormEmail'
                : 'recommendedLoginFormSocial',
            elementAction: isEmail ? Action.NOT_VISIBLE : Action.VISIBLE,
            elementActionValue: isEmail ? NO_VALUE : lastLoginMethod,
            eventName: NO_VALUE,
        },
    };
    return trackingPayload;
};
//# sourceMappingURL=buildLastLoginMethodPayload.js.map